import { formatLabel } from 'utils/utils';

export const GaugeChart = (chartData) => {
  const gaugeChartOption = {
    tooltip: {
      trigger: 'item',
      extraCssText: 'min-width:180px',
      textStyle: {
        fontSize: 8,
      },
      valueFormatter: (num) => formatLabel(num, '%'),
    },
    legend: {
      show: false,
    },
    color: ['#a2c1d9', '#146196'],
    series: [
      {
        type: 'pie',
        radius: ['50%', '90%'],
        label: {
          show: false,
          position: 'center',
        },
        labelLine: {
          show: false,
        },
        center: ['50%', '60%'],
        // adjust the start and end angle
        startAngle: 180,
        endAngle: 360,
        data: chartData,
      },
    ],
  };
  return gaugeChartOption;
};
